 import axios from "axios";
import { useReactToPrint } from "react-to-print";
import logo from '../components/Reports/food.jpeg';

import React, { useState, forwardRef, useImperativeHandle  ,useRef} from 'react';
import {Modal} from 'react-bootstrap';
const LoansReport = forwardRef((props, ref) => {
  const [loans, setLoans] = useState([]);
  const [inviteModal , setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
      showInviteModal() {
        fetchLoans();
          setInviteModal(true)
      }
  
    }));
    const componentRef = useRef();

    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Userdata",
        onAfterPrint: () => alert("Data saved in PDF")
      });
    
  const fetchLoans = async () => {
    try {
      const response = await axios.get("https://subk.education.com.ly/back/api/getloans");
      setLoans(response.data.Receiptexpenses);
    } catch (error) {
      console.error("Error fetching loans:", error);
    }
  };

  return (
<>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>                
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">ديون الموظفين</h1>
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>setInviteModal(false)}></button>
                    </div>
                    <div className="modal-body" dir="rtl" ref={componentRef}>
      <table className=" invoice-table">
         <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

          <tr>
            <th>الموظف</th>
            <th>تاريخ السلفة</th>
            <th>القيمة</th>
          </tr>
        </thead>
        <tbody>
          {loans.length> 0 && loans.map((loan, index) => (
            <tr key={index}>
                              <td>{loan.technician.FirstName}</td>

              <td>{loan.ExpenseDate}</td>
              <td>{loan.Amount}</td>

            </tr>
          ))}
        </tbody>
      </table>
      </div>
      <div className="modal-footer">
            <button type="button" className="btn btn-danger light" onClick={() => setInviteModal(false)}>إلغاء</button>
             <button className="btn btn-success" onClick={generatePDF}>طباعه</button>
          </div>
      </div>
      </Modal>
    </>
  )
})

export default LoansReport;
